'use client';

import React, { type ReactElement } from 'react';

import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';
import { type AllProductsQueryParams } from '@/common/types/product.type';
import { type FilteredDataType } from '@/features/store/types/filter.type';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import Button from '@/common/components/button/button.component';

import Filter from './filter.component';

export interface HeaderProps {
  setOpen: (value: boolean) => void;
  filtered?: boolean;
  payloadSetter?: (payload: AllProductsQueryParams) => void;
  openSearch: (value: boolean) => void;
  categoryList: MultiLevelMenuItem[];
  filteredData: FilteredDataType;
  children?: ReactElement;
}

export default function FilterHeader({
  setOpen,
  filtered,
  openSearch,
  categoryList,
  filteredData,
  payloadSetter,
}: HeaderProps) {
  return (
    <div className="mb-[4px] mt-2 flex w-full items-center justify-between gap-3">
      {isMobile ? (
        <Filter
          categoryList={categoryList}
          payloadSetter={payloadSetter}
          filteredData={filteredData}
          wrapperClassName="flex-1"
        >
          <Button
            type="tonal"
            className={classNames(
              'h-9 w-full !text-xs font-medium ',
              { ' !text-blue-default': filtered },
              {
                ' !text-silver-500': !filtered,
              }
            )}
            onClick={() => {
              setOpen(true);
            }}
            id="store-click-filter-v1"
          >
            فیلتر و مرتب‌سازی
          </Button>
        </Filter>
      ) : null}
      <Button
        type="tonal"
        className="h-9 flex-1 !bg-silver-200 !text-xs font-medium !text-silver-500 lg:hidden"
        onClick={() => {
          openSearch(true);
        }}
        id="store-click-search-v1"
      >
        جست‌و‌جو در محصولات
      </Button>
    </div>
  );
}
